export default __webpack_public_path__ + "41c0aab9a58191c64846eee8b09222cf.svg";